import React, { useState } from "react";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
import aboutbg from "Utils/Assets/Images/aboutbg.png";
import Users1 from "Utils/Assets/Images/Users1.png";
import Package from "Utils/Assets/Images/Package.png";
import VirtualReality from "Utils/Assets/Images/VirtualReality.png";
import VirtualShopping from "Utils/Assets/Images/virtualShopping.png";
import MetaverseEvents2 from "Utils/Assets/Images/metaverseEvents2.png";
import PhasePlaceholder from "../../../Utils/Assets/Images/PhasePlaceholder.png";
import MenuImage from "../../../Utils/Assets/Images/MenuImage.png";

const tabs = [
    { id: "meeting", label: "Host a Meeting", icon: Users1 },
    { id: "shopping", label: "Virtual Shopping", icon: VirtualReality },
    { id: "events", label: "Events", icon: Package },
];

const shoppingFeatures = [
    {
        icon: Users1,
        title: "Smart recommendations",
        desc: "The assistant learns your preferences and suggests products tailored to your taste.",
    },
    {
        icon: Users1,
        title: "Live conversations",
        desc: "Chat with the AI like a salesperson—ask for specs, compare options, or get style advice.",
    },
    {
        icon: Users1,
        title: "Guided shopping experience",
        desc: "Let your AI avatar guide you through the store, explain features, and help with your purchase.",
    },
];

const MeetVREvents = () => {
    const [activeTab, setActiveTab] = useState("meeting");

    return (
        <div className={styles.meetWrapper}>
            <img src={aboutbg} alt="meetBg" className={styles.meetBg} />
            <MeetUsWrapper>
                <div className={styles.meetContent}>
                    <div>
                        <h1 className={styles.meetTitle}>
                            Boost Engagement & Earn More MVR!
                        </h1>
                        <p className={styles.meetDescription}>
                            Interactive activities keep your audience engaged, increasing your MVR rewards.
                        </p>
                    </div>

                    <div className={styles.grid}>
                        {tabs.map((tab) => (
                            <div
                                key={tab.id}
                                className={
                                    activeTab === tab.id
                                        ? styles.meetFeatureActive
                                        : styles.meetFeatureInactive
                                }
                                onClick={() => setActiveTab(tab.id)}
                            >
                                <img src={tab.icon} alt={tab.label} />
                                <p className={styles.meetFeatureText}>
                                    {tab.label}
                                </p>
                            </div>
                        ))}
                    </div>

                    {activeTab === "meeting" && (
                        <div
                            className={styles.earningsContent}
                            data-aos="fade-up"
                            data-aos-duration="600"
                            data-aos-once="false"
                        >
                            <div className={styles.flex}>
                                <div className={styles.earningsFeature}>
                                    <h1 className={styles.title}>
                                        Host a Group Meeting
                                    </h1>
                                    <p className={styles.description}>
                                        Bring your team, friends, or community
                                        together in a fully immersive virtual
                                        space. Whether it's a business meeting,
                                        a brainstorming session, or a casual
                                        hangout.
                                    </p>
                                    <p className={styles.description}>
                                        MeetUsVR provides interactive tools to
                                        enhance communication and
                                        collaboration—plus, you earn MVR Coins
                                        for hosting!
                                    </p>
                                    <div className={styles.earningsButtonWrapper}>
                                        <button>Get Started Now</button>
                                    </div>
                                </div>
                                <div className={styles.earningsFeature}>
                                    <div className={styles.earningsImageWrapper}>
                                        <div className={styles.earningsPhoneFrame}>
                                            <img
                                                src={PhasePlaceholder}
                                                alt="PhasePlaceholder"
                                                className={styles.tabImage}
                                            />
                                        </div>
                                        <img
                                            src={MenuImage}
                                            alt="Feature Host Earning"
                                            className={styles.FeatureHostEarningImage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === "shopping" && (
                        <div
                            className={styles.earningsContent}
                            data-aos="fade-up"
                            data-aos-duration="600"
                            data-aos-once="false"
                        >
                            <div className={styles.flex}>
                                <div className={styles.earningsFeature}>
                                    <h1 className={styles.title}>
                                        A New Way to Shop in the Metaverse
                                    </h1>
                                    <p className={styles.description}>
                                        Explore a 3D shopping experience in
                                        MeetUsVR, where you can browse, try on,
                                        and buy digital and real-world products.
                                    </p>
                                    <div className={styles.featureList}>
                                        {shoppingFeatures.map((f) => (
                                            <div
                                                key={f.title}
                                                className={styles.featureItem}
                                            >
                                                <img
                                                    src={f.icon}
                                                    alt={f.title}
                                                    className={styles.featureIcon}
                                                />
                                                <div className={styles.featureItemText}>
                                                    <span className={styles.featureItemTitle}>
                                                        {f.title}
                                                    </span>
                                                    <span className={styles.featureItemDesc}>
                                                        {f.desc}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className={styles.earningsButtonWrapper}>
                                        <button>Get Started Now</button>
                                    </div>
                                </div>
                                <div className={styles.earningsFeature}>
                                    <div className={styles.earningsImageWrapper}>
                                        <img
                                            src={VirtualShopping}
                                            alt="Virtual Shopping"
                                            className={styles.shoppingImage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === "events" && (
                        <div
                            className={styles.earningsContent}
                            data-aos="fade-up"
                            data-aos-duration="600"
                            data-aos-once="false"
                        >
                            <div className={styles.flex}>
                                <div className={styles.earningsFeature}>
                                    <h1 className={styles.title}>
                                        Attend and Host Exclusive Events
                                    </h1>
                                    <p className={styles.description}>
                                        MeetUsVR redefines connection with
                                        immersive virtual events. Join
                                        networking meetups, concerts, and
                                        interactive sessions from anywhere. Host
                                        your own event, and earn MVR Coins!
                                    </p>
                                    <div className={styles.earningsButtonWrapper}>
                                        <button>Get Started Now</button>
                                    </div>
                                </div>
                                <div className={styles.earningsFeature}>
                                    <div className={styles.earningsImageWrapper}>
                                        <div className={styles.earningsPhoneFrame}>
                                            <img
                                                src={MetaverseEvents2}
                                                alt="Metaverse Events"
                                                className={styles.tabImage}
                                            />
                                        </div>
                                        <img
                                            src={MenuImage}
                                            alt="Menu"
                                            className={styles.FeatureHostEarningImage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default MeetVREvents;
